import * as Actions from '../../actions/estimate/type';

export const EstimateReducer = (state = {}, action) => {
  switch (action.type) {
    // ==============creating jobs from estimate=========
    case Actions.CREATE_JOB_ESTIMATE_REQUEST:
      return {
        ...state,
        createEstimateJobLoader: true,
      };
    case Actions.CREATE_JOB_ESTIMATE_SUCCESS:
      console.log(
        'CREATE_JOB_ESTIMATE_SUCCESS ==> ',
        action.payload?.data?.jobData,
      );

      return {
        ...state,
        createEstimateJobLoader: false,
        createdJob: action.payload?.data?.jobData,
      };
    case Actions.CREATE_JOB_ESTIMATE_FAIL:
      return {
        ...state,
        createEstimateJobLoader: false,
        error: action.payload,
      };

    case Actions.UPDATE_ESTIMATE_JOB_LIST:
      console.log('UPDATE_ESTIMATE_JOB_LISTReducer state >>>>>>', state);
      console.log('UPDATE_ESTIMATE_JOB_LISTReducer >>>>>>', action.payload);
      let jobs = [];
      if (action?.payload?.nexPart) {
        // if items comes from next part to update the jobs items
        // jobs will pass from component which contain updated items
        jobs = [...(action?.payload?.jobs || [])];
      } else if (action?.payload?.partTech) {
        console.log(action.payload, 'action?.payload');
        // if items comes from partTech to update the jobs items
        // jobs will pass from component which contain updated items
        jobs = [...(action?.payload?.jobs || [])];
      } else if (action?.payload?.epicor) {
        console.log(action.payload, 'action?.payload');
        // if items comes from epicor to update the jobs items
        // jobs will pass from component which contain updated items
        jobs = [...(action?.payload?.jobs || [])];
      } else {
        jobs = [...(state?.jobs?.jobs || [])];
      }

      if (action?.payload?.isDelete) {
        const filteredJobs = jobs?.filter(
          (job) => job?.id !== action?.payload?.jobId,
        );
        jobs = filteredJobs;
      } else if (action?.isCanned) {
        jobs = [...jobs, ...action.payload?.data?.jobData];
      } else if (action?.payload?.nexPart) {
        jobs = [...action?.payload?.jobs];
      } else if (action?.payload?.partTech) {
        jobs = [...action?.payload?.jobs];
      } else if (action?.payload?.epicor) {
        jobs = [...action?.payload?.jobs];
      } else {
        jobs = [...jobs, action?.payload?.data?.jobData];
      }
      return {
        ...state,
        jobs: {
          ...state?.jobs,
          jobs: [...jobs],
        },
      };

    // ==============creating multiple jobs from estimate=========
    case Actions.CREATE_JOBS_ESTIMATE_REQUEST:
      return {
        ...state,
        createEstimateJobsLoader: true,
      };
    case Actions.CREATE_JOBS_ESTIMATE_SUCCESS:
      return {
        ...state,
        createEstimateJobsLoader: false,
        createdJobs: action.payload?.data?.jobData,
      };
    case Actions.CREATE_JOBS_ESTIMATE_FAIL:
      return {
        ...state,
        createEstimateJobsLoader: false,
        error: action.payload,
      };

    // ==============getting jobs=========
    case Actions.GET_JOBS_REQUEST:
      return {
        ...state,
        getJobsLoader: true,
        estimateJobsLoader: action?.usedIn === 'estimate' ? true : false,
        authorizeJobsLoader: action?.usedIn === 'authorize' ? true : false,
      };
    case Actions.GET_JOBS_SUCCESS:
      return {
        ...state,
        getJobsLoader: false,
        estimateJobsLoader: action?.usedIn === 'estimate' ? false : false,
        authorizeJobsLoader: action?.usedIn === 'authorize' ? false : false,
        jobs: action.payload?.data?.ro,
        appliedTaxes: action.payload?.data?.appliedTaxes,
      };
    case Actions.GET_JOBS_FAIL:
      return {
        ...state,
        getJobsLoader: false,
        estimateJobsLoader: action?.usedIn === 'estimate' ? false : false,
        authorizeJobsLoader: action?.usedIn === 'authorize' ? false : false,
        error: action.payload,
      };

    // ==============add, update items, parts,supplies, labors etc=========
    case Actions.ADD_UPDATE_ITEMS_REQUEST:
      return {
        ...state,
        addUpdateItemLoader: true,
      };
    case Actions.ADD_UPDATE_ITEMS_SUCCESS:
      return {
        ...state,
        addUpdateItemLoader: false,
        jobItem: action.payload?.data,
      };
    case Actions.ADD_UPDATE_ITEMS_FAIL:
      return {
        ...state,
        addUpdateItemLoader: false,
        error: action.payload,
        jobItemError: action.payload,
      };

    // ==============add, multiple items, parts,supplies, labors etc=========
    case Actions.ADD_ITEMS_REQUEST:
      return {
        ...state,
        addItemsLoader: true,
      };
    case Actions.ADD_ITEMS_SUCCESS:
      return {
        ...state,
        addItemsLoader: false,
        updatedJobItems: action.payload?.data, // canned/labourTimes items
      };
    case Actions.ADD_ITEMS_FAIL:
      return {
        ...state,
        addItemsLoader: false,
        error: action.payload,
      };
    // ==============delete, job items, parts,supplies, labors etc=========
    case Actions.DELETE_JOB_ITEM_REQUEST:
      return {
        ...state,
        deleteJobItemLoader: true,
      };
    case Actions.DELETE_JOB_ITEM_SUCCESS:
      return {
        ...state,
        deleteJobItemLoader: false,
        deletedJobItem: action.payload?.data,
      };
    case Actions.DELETE_JOB_ITEM_FAIL:
      return {
        ...state,
        deleteJobItemLoader: false,
        error: action.payload,
      };

    // ==============adding items, parts,supplies, labors etc to inventory=========
    case Actions.ADD_ITEM_TO_INVENTORY_REQUEST:
      return {
        ...state,
        itemAddLoader: true,
      };
    case Actions.ADD_ITEM_TO_INVENTORY_SUCCESS:
      return {
        ...state,
        itemAddLoader: false,
        inventoryItem: action.payload?.data,
      };
    case Actions.ADD_ITEM_TO_INVENTORY_FAIL:
      return {
        ...state,
        itemAddLoader: false,
        error: action.payload,
      };

    // ==============labours searching=========
    case Actions.SEARCH_LABORS_REQUEST:
      return {
        ...state,
        labourSearchLoader: true,
      };
    case Actions.SEARCH_LABORS_SUCCESS:
      return {
        ...state,
        labourSearchLoader: false,
        labours: action.payload?.result,
      };
    case Actions.SEARCH_LABORS_FAIL:
      return {
        ...state,
        labourSearchLoader: false,
        error: action.payload,
      };

    // ==============part supply searching=========
    case Actions.SEARCH_PART_SUPPLY_REQUEST:
      return {
        ...state,
        partSupplySearchLoader: true,
      };
    case Actions.SEARCH_PART_SUPPLY_SUCCESS:
      return {
        ...state,
        partSupplySearchLoader: false,
        partSupplies: action.payload?.result,
        totalCount: action.payload?.totalCount || 0,
      };
    case Actions.SEARCH_PART_SUPPLY_FAIL:
      return {
        ...state,
        partSupplySearchLoader: false,
        error: action.payload,
      };

    // ==============parts supplies getting list=========
    case Actions.GET_PARTS_SUPPLIES_REQUEST:
      return {
        ...state,
        partsSuplliesLoader: true,
      };
    case Actions.GET_PARTS_SUPPLIES_SUCCESS:
      return {
        ...state,
        partsSuplliesLoader: false,
        allPartsSupplies: action.payload?.data,
      };
    case Actions.GET_PARTS_SUPPLIES_FAIL:
      return {
        ...state,
        partsSuplliesLoader: false,
        error: action.payload,
      };

    // ===========deleting parts supplies================
    case Actions.DELETE_PART_SUPPLY_REQUEST:
      return {
        ...state,
        deletePartSupplyLoader: true,
      };
    case Actions.DELETE_PART_SUPPLY_SUCCESS:
      return {
        ...state,
        deletePartSupplyLoader: false,
        deletedPartSupply: action.payload?.data,
      };
    case Actions.DELETE_PART_SUPPLY_FAIL:
      return {
        ...state,
        deletePartSupplyLoader: false,
        deletePartSupplyError: action.payload,
      };

    // ============ updating part/supply list after deleting item ========
    case Actions.UPDATE_PART_SUPPLY_LIST:
      const itemId = action?.payload?.id;
      const itemType = action?.payload?.type;
      let partsSupplies = state?.allPartsSupplies;

      if (itemType === 'part') {
        const parts = partsSupplies?.parts || [];
        const partsCount = state?.allPartsSupplies?.partsCount || 0;

        const filteredParts = parts?.filter((prt) => prt?.id !== itemId);
        partsSupplies = {
          ...partsSupplies,
          parts: filteredParts,
          partsCount: partsCount - 1,
        };
      } else {
        const supplies = partsSupplies?.supplies || [];

        const suppliesCount = state?.allPartsSupplies?.suppliesCount || 0;
        const filteredSupplies = supplies?.filter(
          (supp) => supp?.id !== itemId,
        );
        partsSupplies = {
          ...partsSupplies,
          supplies: filteredSupplies,
          suppliesCount: suppliesCount - 1,
        };
      }
      return {
        ...state,
        allPartsSupplies: partsSupplies,
      };

    // ============== clearing deleted part/supply state ========
    case Actions.CLEAR_DELETED_PART_SUPPLY_STATE:
      return {
        ...state,
        deletePartSupplyLoader: false,
        deletedPartSupply: '',
        deletePartSupplyError: '',
      };

    // ==============get canned services =========
    case Actions.GET_CANNED_SERVICES_REQUEST:
      return {
        ...state,
        getCannedLoader: true,
      };
    case Actions.GET_CANNED_SERVICES_SUCCESS:
      return {
        ...state,
        getCannedLoader: false,
        cannedServices: action.payload?.resultData,
      };
    case Actions.GET_CANNED_SERVICES_FAIL:
      return {
        ...state,
        getCannedLoader: false,
        error: action.payload,
      };

    // ===========deleting canned services================
    case Actions.DELETE_CANNED_SERVICE_REQUEST:
      return {
        ...state,
        deleteCannedLoader: true,
      };
    case Actions.DELETE_CANNED_SERVICE_SUCCESS:
      return {
        ...state,
        deleteCannedLoader: false,
        deletedCanned: action.payload?.data,
      };
    case Actions.DELETE_CANNED_SERVICE_FAIL:
      return {
        ...state,
        deleteCannedLoader: false,
        deleteCannedError: action.payload,
      };

    // ============== clearing delete canned state ====
    case Actions.CLEAR_DELETE_CANNED_SERVICE_STATE:
      return {
        ...state,
        deleteCannedLoader: false,
        deletedCanned: '',
        deleteCannedError: '',
      };

    // ==============creating estimate =========
    case Actions.ADD_ESTIMATE_REQUEST:
      return { ...state, estimateLoading: true };
    case Actions.ADD_ESTIMATE_SUCCESS:
      const data = action.payload?.data || '';
      return {
        ...state,
        estimateLoading: false,
        createdEstimate: {
          ...data,
          jobs: action.payload?.jobs || [],
        },
      };
    case Actions.ADD_ESTIMATE_FAIL:
      return {
        ...state,
        estimateLoading: false,
        createEstimateError: action.payload,
      };
    // ==============authorizing estimate =========
    case Actions.AUTHORIZE_ESTIMATE_REQUEST:
      return { ...state, authorizeLoading: true };

    case Actions.AUTHORIZE_ESTIMATE_SUCCESS:
      return {
        ...state,
        authorizeLoading: false,
        authorizedEstimate: action.payload || '',
      };
    case Actions.AUTHORIZE_ESTIMATE_FAIL:
      return {
        ...state,
        authorizeLoading: false,
        authorizeEstimateError: action.payload,
      };
    // // update ro isAuthorize key true to hide remove job button
    case Actions.UPDATE_RO_TO_AUTHORIZED:
      return {
        ...state,
        jobs: {
          ...state?.jobs,
          jobs: [...action?.payload?.jobs],
        },
      };

    case Actions.CLEAR_JOBS_STATE:
      return {
        ...state,
        jobs: [],
      };

    // ============== get silos(systems with all data) (motor.com) =========
    case Actions.GET_SILOS_REQUEST:
      return {
        ...state,
        getSiloLoader: true,
      };
    case Actions.GET_SILOS_SUCCESS:
      return {
        ...state,
        getSiloLoader: false,
        silos: action.payload?.data || [],
      };
    case Actions.GET_SILOS_FAIL:
      return {
        ...state,
        getSiloLoader: false,
        siloErr: action.payload,
      };
    // ============== get systems (motor.com) =========
    case Actions.GET_SYSTEMS_REQUEST:
      return {
        ...state,
        getSystemLoader: true,
      };
    case Actions.GET_SYSTEMS_SUCCESS:
      return {
        ...state,
        getSystemLoader: false,
        systems: action.payload?.data || [],
      };
    case Actions.GET_SYSTEMS_FAIL:
      return {
        ...state,
        getSystemLoader: false,
        systemErr: action.payload,
      };
    // ============== get groups (motor.com) =========
    case Actions.GET_GROUPS_REQUEST:
      return {
        ...state,
        getGroupLoading: true,
      };
    case Actions.GET_GROUPS_SUCCESS:
      return {
        ...state,
        getGroupLoading: false,
        groups: action.payload?.data || {},
      };
    case Actions.GET_GROUPS_FAIL:
      return {
        ...state,
        getGroupLoading: false,
        subCatErr: action.payload,
      };

    // ============== get sub groups (motor.com) =========
    case Actions.GET_SUB_GROUPS_REQUEST:
      return {
        ...state,
        getSubGroupLoading: true,
      };
    case Actions.GET_SUB_GROUPS_SUCCESS:
      return {
        ...state,
        getSubGroupLoading: false,
        subGroups: action.payload?.data || {},
      };
    case Actions.GET_SUB_GROUPS_FAIL:
      return {
        ...state,
        getSubGroupLoading: false,
        subCatErr: action.payload,
      };

    // ============== get labor/part guides(just items) (motor.com) =========
    case Actions.GET_TAXONOMIES_REQUEST:
      return {
        ...state,
        getTaxonomyLoading: true,
      };
    case Actions.GET_TAXONOMIES_SUCCESS:
      return {
        ...state,
        getTaxonomyLoading: false,
        taxonomies: action.payload?.data || {},
      };
    case Actions.GET_TAXONOMIES_FAIL:
      return {
        ...state,
        getTaxonomyLoading: false,
        labPartErr: action.payload,
      };

    // ============== get labor/part guides details (motor.com) =========
    case Actions.GET_WORK_TIMES_REQUEST:
      return {
        ...state,
        getWorkTimeLoading: true,
      };
    case Actions.GET_WORK_TIMES_SUCCESS:
      return {
        ...state,
        getWorkTimeLoading: false,
        laborPartsGuide: action.payload || {},
      };
    case Actions.GET_WORK_TIMES_FAIL:
      return {
        ...state,
        getWorkTimeLoading: false,
        guideErr: action.payload,
      };
    // ============== get Procedures (motor.com) =========
    case Actions.GET_PROCEDURES_REQUEST:
      return {
        ...state,
        getProceduresLoader: true,
      };
    case Actions.GET_PROCEDURES_SUCCESS:
      return {
        ...state,
        getProceduresLoader: false,
        procedures: action.payload?.data || [],
      };
    case Actions.GET_PROCEDURES_FAIL:
      return {
        ...state,
        getProceduresLoader: false,
        getProceduresError: action.payload,
      };

    // ============== get single Procedure data (motor.com) =========
    case Actions.GET_PROCEDURE_REQUEST:
      return {
        ...state,
        getProcedureLoader: true,
      };
    case Actions.GET_PROCEDURE_SUCCESS:
      return {
        ...state,
        getProcedureLoader: false,
        procedureData: action.payload?.data || [],
      };
    case Actions.GET_PROCEDURE_FAIL:
      return {
        ...state,
        getProcedureLoader: false,
        getProcedureError: action.payload,
      };

    // ============== get taxonomies for diagrams (motor.com) =========
    case Actions.GET_TAXONOMIES_FOR_DIAGRAMS_REQUEST:
      return {
        ...state,
        diagramTaxonoLoader: true,
      };
    case Actions.GET_TAXONOMIES_FOR_DIAGRAMS_SUCCESS:
      return {
        ...state,
        diagramTaxonoLoader: false,
        diagramsTAxonomies: action.payload?.data || [],
      };
    case Actions.GET_TAXONOMIES_FOR_DIAGRAMS_FAIL:
      return {
        ...state,
        diagramTaxonoLoader: false,
        diagramsTaxoErr: action.payload,
      };

    // ============== get  diagrams (motor.com) =========
    case Actions.GET_DIAGRAMS_REQUEST:
      return {
        ...state,
        diagramLoader: true,
      };
    case Actions.GET_DIAGRAMS_SUCCESS:
      return {
        ...state,
        diagramLoader: false,
        diagrams: action.payload?.data || [],
      };
    case Actions.GET_DIAGRAMS_FAIL:
      return {
        ...state,
        diagramLoader: false,
        diagramErr: action.payload,
      };

    case Actions.CLEAR_ESTIMATED_WORKTIME_STATE:
      return {
        ...state,
        systemErr: '',
      };

    case Actions.CLEAR_MOTOR_STATE:
      return {
        ...state,
        groups: {},
        subGroups: {},
        taxonomies: {},
        laborPartsGuide: {},
        diagramsTAxonomies: [],
        diagrams: [],
      };

    case Actions.CLEAR_ESTIMATE_STATE_DATA:
      return {
        ...state,
        jobItem: {},
        createdJob: {},
        inventoryItem: {},
        createdJobs: [],
        updatedJobItems: {},
        createdEstimate: {},
        createEstimateError: null,
        authorizedEstimate: {},
        authorizeEstimateError: null,
        error: null,
        jobItemError: null,
      };
    case Actions.ADD_NEW_PART_TO_LIST:
      const parts = state?.allPartsSupplies?.parts || [];
      const partsCount = state?.allPartsSupplies?.partsCount || 0;
      parts.unshift(action.payload);

      return {
        ...state,

        allPartsSupplies: {
          ...state.allPartsSupplies,
          parts: [...parts],

          partsCount: partsCount + 1 || 0,
        },
      };

    case Actions.ADD_NEW_SUPPLY_TO_LIST:
      const supplies = state?.allPartsSupplies?.supplies || [];
      const suppliesCount = state?.allPartsSupplies?.suppliesCount || 0;
      supplies.unshift(action.payload);
      return {
        ...state,

        allPartsSupplies: {
          ...state.allPartsSupplies,
          supplies: [...supplies],
          suppliesCount: suppliesCount + 1 || 0,
        },
      };
    case Actions.CLEAR_LABOUR_PARTS_ERRORS_ESTIMATE_STATE:
      return {
        ...state,
        siloErr: '',
      };
    case Actions.CLEAR_PROCEDURES_ERRORS_ESTIMATE_STATE:
      return {
        ...state,
        getProceduresError: '',
        getProcedureError: '',
      };
    case Actions.CLEAR_DIAGRAMS_ERRORS_ESTIMATE_STATE:
      return {
        ...state,
        diagramsTaxoErr: '',
      };

    // ------------------------------Old Estimate reducer----------------------------

    case Actions.GET_ESTIMATE_LISTING_REQUEST:
      return {
        ...state,
        getEstimateListLoading: true,
      };
    case Actions.GET_ESTIMATE_LISTING_SUCCESS:
      return {
        ...state,
        getEstimateListLoading: false,
        estimateList: action.payload,
      };
    case Actions.GET_ESTIMATE_LISTING_FAIL:
      return {
        ...state,
        getEstimateListLoading: false,
        getEstimateListError: action.payload,
      };

    case Actions.UPDATE_ESTIMATE_REQUEST:
      return {
        ...state,
        updateEstimateLoading: true,
      };
    case Actions.UPDATE_ESTIMATE_SUCCESS:
      return {
        ...state,
        updateSuccess: true,
        updateEstimateLoading: false,
        updatedEstimate: action.payload,
      };
    case Actions.UPDATE_ESTIMATE_FAIL:
      return {
        ...state,
        updateEstimateLoading: false,
        updateEstimateError: action.payload,
      };
    case Actions.CLEAR_UPDATED_ESTIMATE_STATE:
      return {
        ...state,
        updateSuccess: false,
        updateEstimateLoading: false,
        updateEstimateError: null,
        updatedEstimate: null,
      };

    default:
      return state;
  }
};

export const requestForChange = (state = {}, action) => {
  switch (action.type) {
    case Actions.REQUEST_FOR_CHANGE_REQUEST:
      return {
        ...state,
        requestForChangeLoading: true,
      };
    case Actions.REQUEST_FOR_CHANGE_SUCCESS:
      return {
        ...state,
        requestForChangeLoading: false,
        requestForChangeData: action.payload?.data || null,
      };
    case Actions.REQUEST_FOR_CHANGE_FAIL:
      return {
        ...state,
        requestForChangeLoading: false,
        requestForChangeError: action.payload,
      };
    case Actions.CLEAR_REQUEST_FOR_CHANGE_STATE:
    case 'CLEAR_REQUEST_FOR_CHANGE_STATE':
      return {
        ...state,
        requestForChangeData: null,
        requestForChangeLoading: false,
        requestForChangeError: null,
      };
    default:
      return state;
  }
};

// Delete Estimate
export const deleteEstimateReducer = (state = {}, action) => {
  switch (action.type) {
    case Actions.DELETE_ESTIMATE_REQUEST:
      return {
        ...state,
        deleteEstimateLoading: true,
      };
    case Actions.DELETE_ESTIMATE_SUCCESS:
      return {
        ...state,
        deleteEstimateLoading: false,
        deleteEstimateSuccess: action.payload,
      };
    case Actions.DELETE_ESTIMATE_FAIL:
      return {
        ...state,
        deleteEstimateLoading: false,
        error: action.payload,
      };
    case Actions.CLEAR_DELETE_ESTIMATE_STATES:
      return {
        ...state,
        deleteEstimateLoading: false,
        error: null,
        deleteEstimateSuccess: null,
      };
    default:
      return state;
  }
};

export const GetSingleEstimateReducer = (state = {}, action) => {
  switch (action.type) {
    case Actions.GET_ESTIMATE_BY_ID_REQUEST:
      return { ...state, loading: true, estimate: '', error: '' };
    case Actions.GET_ESTIMATE_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        estimate: action.payload?.data || '',
      };
    case Actions.GET_ESTIMATE_BY_ID_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case Actions.CLEAR_GET_ESTIMATE_BY_ID_STATE:
      return {
        ...state,
        loading: false,
        error: null,
        estimate: null,
      };

    default:
      return state;
  }
};

// export const AddReducer = (state = {}, action) => {
//   switch (action.type) {
//     case Actions.ADD_ESTIMATE_REQUEST:
//       return { loading: true };
//     case Actions.ADD_ESTIMATE_SUCCESS:
//       return {
//         ...state,
//         loading: false,
//         createdEstimate: action.payload?.data || '',
//       };
//     case Actions.ADD_ESTIMATE_FAIL:
//       return {
//         ...state,
//         loading: false,
//         error: action.payload,
//       };
//     case Actions.CLEAR_ADD_ESTIMATE_STATE:
//       return {
//         ...state,
//         loading: false,
//         success: false,
//         createdEstimate: null,
//         error: null,
//       };
//     default:
//       return state;
//   }
// };

// add labour
// export const AddLaborReducer = (state = {}, action) => {
//   switch (action.type) {
//     case Actions.ADD_LABOR_REQUEST:
//       return { loading: true };
//     case Actions.ADD_LABOR_SUCCESS:
//       return {
//         ...state,
//         loading: false,
//         newLabor: action.payload,
//         success: true,
//       };
//     case Actions.ADD_LABOR_FAIL:
//       return {
//         ...state,
//         loading: false,
//         error: action.payload,
//         success: false,
//       };
//     case Actions.CLEAR_ADD_LABOR_STATE:
//       return {
//         ...state,
//         newLabor: {},
//         success: false,
//         error: null,
//       };
//     default:
//       return state;
//   }
// };

// Search Labor By Category
// export const SearchLaborReducer = (state = {}, action) => {
//   switch (action.type) {
//     case Actions.SEARCH_LABOR_REQUEST:
//       return { loading: true };
//     case Actions.SEARCH_LABOR_SUCCESS:
//       return {
//         ...state,
//         loading: false,
//         searchedLabor: action.payload,
//       };
//     case Actions.SEARCH_LABOR_FAIL:
//       return {
//         ...state,
//         loading: false,
//         error: action.payload,
//       };
//     case Actions.CLEAR_SEARCH_LABOR:
//       return {
//         ...state,
//         loading: false,
//         searchedLabor: '',
//       };
//     default:
//       return state;
//   }
// };

// add part
export const AddPartReducer = (state = {}, action) => {
  switch (action.type) {
    case Actions.ADD_PART_REQUEST:
      return { ...state, loading: true };
    case Actions.ADD_PART_SUCCESS:
      return {
        ...state,
        loading: false,
        newPart: action.payload,
        success: true,
      };
    case Actions.ADD_PART_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case Actions.CLEAR_ADD_PARTS_STATE:
      return {
        ...state,
        newPart: {},
        success: false,
        error: null,
      };
    default:
      return state;
  }
};

// get single part
export const GetPartReducer = (state = {}, action) => {
  switch (action.type) {
    case Actions.GET_PART_REQUEST:
      return { ...state, loading: true };
    case Actions.GET_PART_SUCCESS:
      return {
        ...state,
        loading: false,
        part: action.payload?.data || '',
        partSuccess: true,
      };
    case Actions.GET_PART_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        partSuccess: false,
      };
    case Actions.CLEAR_GET_PARTS_STATE:
      return {
        ...state,
        part: '',
        error: null,
        partSuccess: false,
      };
    default:
      return state;
  }
};

// get single supply data
export const GetSupplyReducer = (state = {}, action) => {
  switch (action.type) {
    case Actions.GET_SUPPLY_REQUEST:
      return { ...state, loading: true };
    case Actions.GET_SUPPLY_SUCCESS:
      return {
        ...state,
        loading: false,
        supply: action.payload?.data || '',
        supplySuccess: true,
      };
    case Actions.GET_SUPPLY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        supplySuccess: false,
      };
    case Actions.CLEAR_GET_SUPPLY_STATE:
      return {
        ...state,
        supply: '',
        error: null,
        supplySuccess: false,
      };
    default:
      return state;
  }
};
// update part
export const UpdatePartReducer = (state = {}, action) => {
  switch (action.type) {
    case Actions.UPDATE_PART_REQUEST:
      return { ...state, updatePartLoading: true };
    case Actions.UPDATE_PART_SUCCESS:
      return {
        ...state,
        updatePartLoading: false,
        updatedPartData: action.payload?.data,
      };
    case Actions.UPDATE_PART_FAIL:
      return {
        ...state,
        updatePartLoading: false,
        updatePartError: action.payload,
      };

    case Actions.CLEAR_UPDATE_PARTS_STATE:
      return {
        ...state,
        updatedPartData: '',
        updatePartLoading: false,
        updatePartError: null,
      };
    default:
      return state;
  }
};

// ADD Supply Item
export const AddItemReducer = (state = {}, action) => {
  switch (action.type) {
    case Actions.ADD_ITEM_REQUEST:
      return { ...state, loading: true };
    case Actions.ADD_ITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        newItem: action.payload,
        success: true,
      };
    case Actions.ADD_ITEM_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case Actions.CLEAR_ADD_SUPPLY_STATE:
      return {
        ...state,
        newItem: {},
        success: false,
        error: null,
      };
    default:
      return state;
  }
};

// update Supply Item
export const UpdateSupplyReducer = (state = {}, action) => {
  switch (action.type) {
    case Actions.UPDATE_SUPPLY_REQUEST:
      return { ...state, updatedSupplyLoading: true };
    case Actions.UPDATE_SUPPLY_SUCCESS:
      return {
        ...state,
        updatedSupplyLoading: false,
        updatedSupplyData: action.payload?.data,
      };
    case Actions.UPDATE_SUPPLY_FAIL:
      return {
        ...state,
        updatedSupplyLoading: false,
        error: action.payload,
      };
    case Actions.CLEAR_UPDATE_SUPPLY_STATE:
      return {
        ...state,
        updatedSupplyData: '',
        updatedSupplyLoading: false,
        error: null,
      };
    default:
      return state;
  }
};

// Search Supply By Name

export const SearchSupplyByNameReducer = (state = {}, action) => {
  switch (action.type) {
    case Actions.SEARCH_SUPPLY_BY_NAME_REQUEST:
      return { ...state, loading: true };
    case Actions.SEARCH_SUPPLY_BY_NAME_SUCCESS:
      return {
        ...state,
        loading: false,
        searchedSupplyItem: action.payload,
      };
    case Actions.SEARCH_SUPPLY_BY_NAME_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

// Search Supply By Vendor

export const SearchSupplyByVendorReducer = (state = {}, action) => {
  switch (action.type) {
    case Actions.SEARCH_SUPPLY_BY_VENDOR_REQUEST:
      return { ...state, loading: true };
    case Actions.SEARCH_SUPPLY_BY_VENDOR_SUCCESS:
      return {
        ...state,
        loading: false,
        searchedSupplyVendor: action.payload,
      };
    case Actions.SEARCH_SUPPLY_BY_VENDOR_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const PartsSearchReducer = (state = {}, action) => {
  switch (action.type) {
    case Actions.PARTS_SEARCH_REQUEST:
      return { ...state, loading: true };
    case Actions.PARTS_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        searchedParts: action.payload,
      };
    case Actions.PARTS_SEARCH_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const VendorSearchReducer = (state = {}, action) => {
  switch (action.type) {
    case Actions.VENDOR_SEARCH_REQUEST:
      return { ...state, loading: true };
    case Actions.VENDOR_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        searchedVendor: action.payload,
      };
    case Actions.VENDOR_SEARCH_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const VehicleMakeSearchReducer = (state = {}, action) => {
  switch (action.type) {
    case Actions.VEHICLE_MAKE_SEARCH_REQUEST:
      return { ...state, loading: true };
    case Actions.VEHICLE_MAKE_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        searchedVehicleMake: action.payload,
      };
    case Actions.VEHICLE_MAKE_SEARCH_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const VehicleModelSearchReducer = (state = {}, action) => {
  switch (action.type) {
    case Actions.VEHICLE_MODEL_SEARCH_REQUEST:
      return { ...state, loading: true };
    case Actions.VEHICLE_MODEL_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        searchedVehicleModel: action.payload,
      };
    case Actions.VEHICLE_MODEL_SEARCH_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const ModelYearSearchReducer = (state = {}, action) => {
  switch (action.type) {
    case Actions.MODEL_YEAR_SEARCH_REQUEST:
      return { loading: true };
    case Actions.MODEL_YEAR_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        searchedModelYear: action.payload,
      };
    case Actions.MODEL_YEAR_SEARCH_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
